import { getOsEnv, getOsEnvOptional } from './libs/env'

/**
 * Environment variables
 */
const env = {
  node: getOsEnvOptional('APP_ENV') || 'local',
  env: getOsEnv('REACT_APP_ENV'),

  app: {
    backend_url: getOsEnv('REACT_APP_BACKEND_URL'),
    api_prefix: getOsEnv('REACT_APP_API_PREFIX'),
    api_prefix_email: getOsEnv('REACT_APP_API_PREFIX_EMAIL'),
  },
}

export default env
